<template>
  <el-dialog title="修改密码" :visible="changePasswordVisible" @close='btnCancel()' class="changePassword" width="570px">
    <el-form ref="changePasswordForm" :model="changePasswordForm" :rules="changePasswordRules" class="form" label-width="140px">
      <el-form-item label="原始密码" prop="oldPassword">
        <el-input v-model="changePasswordForm.oldPassword" auto-complete="off" show-password maxlength="16" placeholder="请输入原始密码"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input v-model="changePasswordForm.newPassword" auto-complete="off" show-password maxlength="16" placeholder="请输入英文+数字组合，至少8位的新密码"></el-input>
      </el-form-item>
      <el-form-item label="重复新密码" prop="repeatPassword">
        <el-input v-model="changePasswordForm.repeatPassword" auto-complete="off" show-password maxlength="16" placeholder="重复输入新密码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit('changePasswordForm')" class="fl">保存</el-button>
        <el-button @click="resetForm('changePasswordForm')" class="fl">重置</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import myLocalStorage from '../../config/myLocalStorage'
// 表单验证
import { notNullable, passwordFormat } from '@/components/form/formValidation'

export default {
  // 组件名称
  name: 'changePassword',
  // 组件参数 接收来自父组件的数据
  props: {
  },
  data () {
    // 重复密码验证
    const pwdAgainCheck = async (rule, value, callback) => {
      if (this.changePasswordForm.newPassword !== this.changePasswordForm.repeatPassword) {
        return callback(new Error('两次输入密码不一致！'))
      } else {
        callback()
      }
    }
    return {
      changePasswordVisible: false,
      changePasswordForm: {
        oldPassword: '',
        newPassword: '',
        repeatPassword: ''
      },
      changePasswordRules: {
        oldPassword: [
          notNullable('请填写原始密码')
        ],
        newPassword: [
          notNullable('请填写新密码'),
          passwordFormat('新密码')
        ],
        repeatPassword: [
          notNullable('请重复输入新密码'),
          { required: true, validator: pwdAgainCheck, trigger: 'blur' }
        ]
      },
      changePasswordParam: []
    }
  },
  created () {

  },
  mounted () {
  },
  methods: {
    onSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.changePasswordParam = {
            'nowPassWord': this.$md5(this.changePasswordForm.newPassword + ''),
            'oldPassWord': this.$md5(this.changePasswordForm.oldPassword + '')
          }
          this.$service.post('/api/user/password', this.changePasswordParam).then(res => {
            this.$message({
              showClose: true,
              message: '修改密码成功，即将为您跳转登录页',
              type: 'success',
              duration: 2000
            })
            let _this = this
            setTimeout(function () {
              // 清除 storage
              myLocalStorage.removeData('dydnz_access_token')
              myLocalStorage.removeData('dydnz_refresh_token')
              _this.$router.push('/login')
            }, 2000)
          }).catch(Err => {

          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 重置表单
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    btnCancel() {
      this.resetForm('changePasswordForm')
      // 关闭弹层
      this.changePasswordVisible = false
    }
  }
}
</script>
<style lang="less">
@import './../../styles/common/public.less';
.changePassword{
  .form{
    .el-form-item{
      .text{
        margin-left: 25px;
      }
    }
    .el-input{
      width: 340px;
    }
    .el-radio-group{
      width: 120px;
      padding-top: 8px;
      .el-radio{
        width: 100%;
        margin: 0 0 12px;
        line-height: 25px;
        .el-radio__label{
          b{
            width: 91px;
            font-weight: normal;
            display: inline-block;
          }
          span{
            display: inline-block;
            color: @spanColor;
          }
        }
      }
    }
    .el-button{
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/accountInfoCenter/changePassword.vue